(function () {
  'use strict';

  angular
    .module('petstore', ['ngAnimate', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria',
      'ngResource', 'ui.router', 'ui.bootstrap', 'ui.bootstrap.showErrors', 'ngMockE2E']);

})();

(function() {
  'use strict';

  angular
    .module('petstore')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController() {
    var vm = this;
  }
})();

(function() {
  'use strict';

  angular
    .module('petstore')
    .controller('AddController', AddController);

  /** @ngInject */
  function AddController() {
    var vm = this;
  }
})();

(function() {
  'use strict';

  angular
    .module('petstore')
    .directive('psNavbar', navbar);

  /** @ngInject */
  function navbar() {
    var directive = {
      replace:true,
      restrict: 'E',
      templateUrl: 'app/layout/navbar/navbar.html',
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController() {
      //var vm = this;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('petstore')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController() {
    var vm = this;
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .directive('psFooter', psFooter);

  /** @ngInject */
  function psFooter() {
    var directive = {
      restrict: 'AE',
      templateUrl: 'app/layout/footer/footer.html',
      controller: FooterController,
      controllerAs: 'vm',
      scope: true
    };

    return directive;

    /** @ngInject */
    function FooterController() {
      //var vm = this;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .directive('psPetThumbnail', petThumbnail);

  /** @ngInject */
  function petThumbnail(petActive) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/pet-thumbnail/pet-thumbnail.html',
      controller: PetThumbnailController,
      controllerAs: 'vm',
      bindToController: true,
      scope: true,
      link: link
    };

    return directive;

    /** @ngInject */
    function PetThumbnailController() {
      var vm = this;
      vm.rating = 4;
      vm.active = petActive;

      vm.delete = petActive.delete;
    }

    function link(scope) {
      // when the element is removed - focus on body???
      scope.$watch('$destroy', function () {
        angular.element('body').focus();
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .directive('psPetCarousel', psPetCarousel);

  /** @ngInject */
  function psPetCarousel() {

    var directive = {
      restrict: 'EA',
      replace: true,
      templateUrl: 'app/components/pet-thumbnail/pet-carousel.html',
      controller: PetCarouselController,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        images: '='
      }
    };

    return directive;

    /** @ngInject */
    function PetCarouselController() {
      var vm = this;
      vm.slides = [];

      vm.interval = 5000;
      vm.noWrapSlides = false;

      function addSlide(image) {
        vm.slides.push({
          image: image
        });
      };
      vm.images.forEach(addSlide)
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .directive('psPetSearch', petSearch);

  /** @ngInject */
  function petSearch(petActive) {

    var directive = {
      restrict: 'EA',
      replace: true,
      templateUrl: 'app/components/pet-search/pet-search.html',
      controller: PetSearchController,
      controllerAs: 'vm',
      bindToController: true,
      scope: true
    };

    return directive;

    /** @ngInject */
    function PetSearchController(Pet) {
      var vm = this;
      vm.petId;
      vm.busy = false;
      vm.search = search;

      function search() {
        vm.busy = true;

        Pet.get({'petId': vm.petId}).$promise.then(function (aPet) {
          petActive.pet = aPet;
        })['finally'](function () {
          vm.busy = false;
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .directive('psPetAdd', petAdd);

  /** @ngInject */
  function petAdd(Pet, alertService) {

    var directive = {
      restrict: 'EA',
      replace: true,
      templateUrl: 'app/components/pet-add/pet-add.html',
      controller: PetAddController,
      controllerAs: 'vm',
      bindToController: true,
      scope: true
    };

    return directive;

    /** @ngInject */
    function PetAddController($scope) {
      var vm = this;

      vm.add = add;

      function reset() {
        $scope.$broadcast('show-errors-reset');
        vm.data = {};
      }

      function add() {
        function tagMap(val, i) {
          return {id: i, name: val};
        };

        var pet = new Pet({
          name: vm.data.name,
          tags: vm.data.tags ? JSON.parse(vm.data.tags).map(tagMap) : [],
          status: vm.data.status ? 'available' : 'outofstock',
          photoUrls: [vm.data.image]
        });

        vm.busy = true;
        pet.$save().then(function (resp) {
          alertService.addAlert({type: 'success', msg: "Well done! You successfully added " + vm.data.name});
          reset();
        })['catch'](function () {
          alertService.addAlert({type: 'danger', msg: "Sorry, the operation is failed. Try again!"});
        }) ['finally'](function () {
          vm.busy = false;
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .directive('psBusyButton', psBusyButton);

  /** @ngInject */
  function psBusyButton() {
    var directive = {
      restrict: 'A',
      link: link
    };

    return directive;

    function link(scope, element, attrs) {
      var busyAria =
        angular.element('<div role="region" class="sr-only" aria-live="assertive"></div>');
      element.parent().after(busyAria);
      var orig = element.text();

      attrs.$observe('psBusyButton', function (val) {
        if (val === 'true') {
          busyAria.text('Busy working button. Please wait...');
          element.text('Working...');
          element.prop('aria-hidden', 'true');
          element.prop('disable', true);
        }
        else {
          busyAria.text('');
          element.prop('disable', false);
          element.prop('aria-hidden', 'false');
          element.text(orig);
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .directive('psAlerts', alerts);

  /** @ngInject */
  function alerts() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/alerts/alerts.html',
      controller: AlertsController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AlertsController(alertService) {
      var vm = this;
      vm.alerts = alertService.alerts;
      vm.closeAlert = alertService.closeAlert;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .service('petActive', petActive);

  /** @ngInject */
  function petActive(Pet, alertService) {
    var that = this;
    this.pet;

    this.delete = function (petId) {
      Pet.delete({petId: petId}).$promise.then(function () {
        alertService.addAlert({
          type: 'success',
          msg: "Well done! You successfully deleted " + that.pet.name
        });
        that.pet = null;
      })['catch'](function (error) {
        alertService.addAlert({
          type: 'danger',
          msg: "We're sorry. We were unable to complete your request due to an unexpected error. Please try again."
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .service('alertService', alertService);

  /** @ngInject */
  function alertService() {
    this.alerts = [];

    this.addAlert = function (alert) {
      this.alerts.push(alert);
    };

    this.closeAlert = function (index) {
      this.alerts.splice(index, 1);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .factory('Pet', Pet);

  /** @ngInject */
  function Pet($resource, resourceError) {
    return $resource('/petstore/api/pet/:petId', {petId: '@id'}, {
      save: {
        method: 'POST',
        interceptor: {responseError: resourceError}
      },
      delete: {
        method: 'DELETE',
        interceptor: {responseError: resourceError}
      },
      get: {
        interceptor: {responseError: resourceError}
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .service('loginModal', loginModal);

  /** @ngInject */
  function loginModal($modal, $rootScope) {
    function assignCurrentUser(user) {
      $rootScope.currentUser = user;
      return user;
    }

    return function () {
      var instance = $modal.open({
        templateUrl: '/app/login/loginModalTemplate.html',
        controller: 'LoginModalCtrl',
        controllerAs: 'vm'
      });

      return instance.result.then(assignCurrentUser);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .controller('LoginModalCtrl', LoginModalCtrl);

  /** @ngInject */
  function LoginModalCtrl($scope, $http) {

    this.cancel = $scope.$dismiss;

    this.submit = function (user, password) {
      $http({
        url: '/petstore/api/login',
        method: 'POST',
        data: {
          username:user,
          password:password
        }
      }).then(function (response) {
        $scope.$close(user);
      }, function (error) {
        $log.error(error);
      });
    };
  }
})();

/*! angular-bootstrap-show-errors (version 2.3.0) 2015-01-19 */
(function(){var a;a=angular.module("ui.bootstrap.showErrors",[]),a.directive("showErrors",["$timeout","showErrorsConfig","$interpolate",function(a,b,c){var d,e,f;return e=function(a){var c;return c=b.trigger,a&&null!=a.trigger&&(c=a.trigger),c},d=function(a){var c;return c=b.showSuccess,a&&null!=a.showSuccess&&(c=a.showSuccess),c},f=function(b,f,g,h){var i,j,k,l,m,n,o,p;if(i=!1,m=b.$eval(g.showErrors),n=d(m),p=e(m),j=f[0].querySelector(".form-control[name]"),l=angular.element(j),k=c(l.attr("name")||"")(b),!k)throw"show-errors element has no child input elements with a 'name' attribute and a 'form-control' class";return l.bind(p,function(){return i=!0,o(h[k].$invalid)}),b.$watch(function(){return h[k]&&h[k].$invalid},function(a){return i?o(a):void 0}),b.$on("show-errors-check-validity",function(){return o(h[k].$invalid)}),b.$on("show-errors-reset",function(){return a(function(){return f.removeClass("has-error"),f.removeClass("has-success"),i=!1},0,!1)}),o=function(a){return f.toggleClass("has-error",a),n?f.toggleClass("has-success",!a):void 0}},{restrict:"A",require:"^form",compile:function(a,b){if(-1===b.showErrors.indexOf("skipFormGroupCheck")&&!a.hasClass("form-group")&&!a.hasClass("input-group"))throw"show-errors element does not have the 'form-group' or 'input-group' class";return f}}}]),a.provider("showErrorsConfig",function(){var a,b;a=!1,b="blur",this.showSuccess=function(b){return a=b},this.trigger=function(a){return b=a},this.$get=function(){return{showSuccess:a,trigger:b}}})}).call(this);
(function () {
  'use strict';

  angular
    .module('petstore')
    .factory('resourceError', resourceError);

  /** @ngInject */
  function resourceError($log, $q) {
    return function resourceErrorHandler(data) {
      $log.error("resourceError interceptor: " + data);

      if(data.status === '404') {
        $log.error("Not found!!!");
      }
      else if(data.status === '400') {
        $log.error("Invalid request!!!");
      }

      return $q.reject(data);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .factory('pet', pet);

  /** @ngInject */
  function pet($resource, resourceError) {
    return $resource('/petstore/api/pet', null, {
      query: {
        isArray: true,
        cache: true,
        interceptor : {responseError : resourceError}
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .config(m2e2Timeout)
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $httpBackend) {

    $log.debug('runBlock end');

    var addPet =
    {};


    $httpBackend.whenPOST('/petstore/api/pet').respond(addPet);

    var getPet = {
      "id": 1,
      "name": "Haireless guinea pig",
      "photoUrls": [
        "assets/pets/1.jpg",
        "assets/pets/2.jpg",
        "assets/pets/3.jpg",
        "assets/pets/4.jpg"
      ],
      "tags": [
        {
          "id": 0,
          "name": "rodents"
        },
        {
          "id": 1,
          "name": "small"
        },
        {
          "id": 2,
          "name": "kids"
        }
      ],
      "status": "available"
    };
    $httpBackend.whenGET('/petstore/api/pet/1').respond(getPet);

    var delPet = {};
    $httpBackend.whenDELETE('/petstore/api/pet/1').respond(delPet);

    $httpBackend.whenGET(/\.html$/).passThrough();

  }

  function m2e2Timeout($httpProvider) {

    $httpProvider.interceptors.push(function ($q, $timeout, $log) {
      return {
        'request': function (config) {
          $log.log('Requesting ' + config.url, config);
          return config;
        },
        'response': function (response) {
          var deferred = $q.defer();

          //Let through views immideately
          if (response.config.url.indexOf(".html") !== -1) return response;

          $timeout(function () {
            deferred.resolve(response);
          }, 2000);

          return deferred.promise;
        }

      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('petstore')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('container', {
        abstract: true,
        templateUrl: 'app/layout/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
/*        data: {
          requireLogin: true
        }*/
      })
      .state('container.home', {
        url: '/',
        views: {
          'main@container': {
            templateUrl: 'app/states/home/home.html',
            controller: 'HomeController',
            controllerAs: 'home'
          }
        }
      }).state('container.add', {
        url: '/add',
        views: {
          'main@container': {
            templateUrl: 'app/states/add/add.html',
            controller: 'AddController',
            controllerAs: 'add'
          }
        }
      });

    $urlRouterProvider.otherwise('/');
  }

})();

(function() {
  'use strict';

  angular
    .module('petstore');

})();

(function() {
  'use strict';

  angular
    .module('petstore')
    //.config(loginConfig)
    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
  }

  function loginConfig($httpProvider) {

    $httpProvider.interceptors.push(function ($timeout, $q, $injector) {
      var loginModal, $http, $state;

      // this trick must be done so that we don't receive
      // `Uncaught Error: [$injector:cdep] Circular dependency found`
      $timeout(function () {
        loginModal = $injector.get('loginModal');
        $http = $injector.get('$http');
        $state = $injector.get('$state');
      });

      return {
        responseError: function (rejection) {
          if (rejection.status !== 401) {
            return rejection;
          }

          var deferred = $q.defer();

          loginModal()
            .then(function () {
              deferred.resolve($http(rejection.config));
            })
            .catch(function () {
              deferred.reject(rejection);
            });

          return deferred.promise;
        }
      };
    });
  }

})();

angular.module("petstore").run(["$templateCache", function($templateCache) {$templateCache.put("app/login/loginModalTemplate.html","<div class=\"modal-body\"><h4 class=\"text-center\">Login to PetStore</h4><br><form class=\"form-inline\" ng-submit=\"vm.submit(_email, _password)\"><div class=\"form-group\"><label for=\"exampleInputName2\">Name</label> <input type=\"text\" class=\"form-control\" id=\"exampleInputName2\" ng-model=\"_email\"></div><div class=\"form-group\"><label for=\"exampleInputEmail2\">Password</label> <input type=\"password\" class=\"form-control\" id=\"exampleInputEmail2\" ng-model=\"_password\"></div><button type=\"submit\" class=\"btn btn-primary\">Log In</button></form></div>");
$templateCache.put("app/components/alerts/alerts.html","<div class=\"col-sm-8 col-sm-offset-2\" aria-live=\"assertive\"><div ng-show=\"vm.alerts.length\"><alert ng-repeat=\"alert in vm.alerts\" role=\"alert\" tabindex=\"0\" type=\"{{alert.type}}\" close=\"vm.closeAlert($index)\">{{ alert.msg }} <span class=\"sr-only\">Click on close button to hide message</span></alert></div></div>");
$templateCache.put("app/components/pet-add/pet-add.html","<form class=\"form-horizontal pet-add\" ng-submit=\"vm.add()\" name=\"userForm\"><div class=\"form-group\" show-errors=\"\"><label for=\"name\" class=\"col-sm-2 col-md-offset-1 control-label\">Name</label><div class=\"col-sm-10 col-md-6\"><input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"vm.data.name\" placeholder=\"Name (min 2 chars)\" name=\"name\" ng-required=\"true\" ng-maxlength=\"10\"></div></div><div class=\"form-group\" show-errors=\"\"><label for=\"tags\" class=\"col-sm-2 col-md-offset-1 control-label\">Tags</label><div class=\"col-sm-10 col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.data.tags\" id=\"tags\" name=\"tags\" placeholder=\'Type multiple tags using json style (example [\"kids\", \"small\"])\'></div></div><div class=\"form-group\" show-errors=\"\"><label for=\"image\" class=\"col-sm-2 col-md-offset-1 control-label\">Image URL</label><div class=\"col-sm-10 col-md-6\"><input type=\"url\" class=\"form-control\" ng-model=\"vm.data.image\" id=\"image\" name=\"image\" placeholder=\"Image URL\" required=\"true\"></div></div><div class=\"form-group\" show-errors=\"\"><div class=\"col-sm-offset-3 col-sm-10 col-md-6\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.data.status\" name=\"status\"> Active Status</label></div></div></div><div class=\"form-group add-footer\"><div class=\"col-sm-offset-3 col-sm-10\"><a ui-sref=\"container.home\" class=\"btn btn-link\">Cancel</a> <button type=\"submit\" class=\"btn btn-dark\" ng-disabled=\"userForm.$invalid\" ps-busy-button=\"{{vm.busy}}\">Add Pet</button></div></div></form>");
$templateCache.put("app/components/pet-search/pet-search.html","<form class=\"form-horizontal\" ng-submit=\"vm.search()\"><div class=\"form-group\"><label for=\"petId\" class=\"col-sm-2 col-sm-offset-1 control-label\">Pet Identifier</label><div class=\"col-sm-6 col-xs-12 search-box\" role=\"search\"><span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span> <input type=\"text\" ng-model=\"vm.petId\" class=\"form-control\" id=\"petId\" placeholder=\"Type here to search by pet identifier\"> <span id=\"helpBlock\" class=\"help-block\">You need to know pet identifier to find your new friend!</span></div><div class=\"col-sm-2\"><button type=\"submit\" class=\"btn btn-dark col-xs-12\" ps-busy-button=\"{{vm.busy}}\" aria-controls=\"pet-thumbnail\">Search</button></div></div></form>");
$templateCache.put("app/components/pet-thumbnail/pet-carousel.html","<div style=\"height: 250px\"><carousel interval=\"vm.interval\" no-wrap=\"vm.noWrapSlides\"><slide ng-repeat=\"slide in vm.slides\" active=\"slide.active\"><img ng-src=\"{{slide.image}}\" style=\"margin:auto;\"></slide></carousel></div>");
$templateCache.put("app/components/pet-thumbnail/pet-thumbnail.html","<div class=\"pet-thumbnail\" id=\"pet-thumbnail\" role=\"region\" aria-live=\"assertive\"><div class=\"panel panel-default\" ng-if=\"vm.active.pet\"><div class=\"panel-heading clearfix\"><h4 class=\"panel-title pull-left\" style=\"padding-top: 7.5px;\">Your awesome pet is {{ vm.active.pet.name }}!</h4><button type=\"button\" class=\"close\" ng-click=\"vm.delete(vm.active.pet.id);\"><span aria-hidden=\"true\">× <span class=\"hide-mobile\">Remove</span></span> <span class=\"sr-only\">Remove</span></button></div><div class=\"panel-body\"><div class=\"col-sm-5 thumbnail-cell thumbnail-carousel\"><ps-pet-carousel images=\"vm.active.pet.photoUrls\"></ps-pet-carousel></div><div class=\"col-sm-4 thumbnail-cell description text-center\"><h3>{{ vm.active.pet.name }}</h3><ul><li data-ng-repeat=\"tag in vm.active.pet.tags\" class=\"badge\">{{ tag.name }}</li></ul><p>The Skinny Pig is an almost hairless breed of Guinea pig. Skinny pigs typically have hair on their muzzles, feet, and legs, but are hairless over the remainder of their bodies. Some of them have a thin covering of fuzzy hair on their backs as well.</p></div><div class=\"col-sm-3 thumbnail-cell price\"><div class=\"row\"><h3 class=\"text-center panel-title price\">$89<span class=\"price-cents\">99</span></h3><div class=\"pet-rating\"><rating ng-model=\"vm.rating\" max=\"5\" titles=\"[\'one\',\'two\',\'three\']\"></rating></div><button class=\"btn btn-success col-sm-6\" ng-if=\"vm.active.pet.status === \'available\'\">Add to Cart</button></div></div></div></div></div>");
$templateCache.put("app/layout/footer/footer.html","<div class=\"row\"><div class=\"col-sm-12 footer-content\"><div class=\"text-center\"><h5 class=\"row\"><span class=\"col-xs-12 col-sm-6\">Power by Julia Passynkova</span> <span><span class=\"glyphicon glyphicon-envelope\" aria-hidden=\"true\"></span> Email: <a href=\"mailto:ipassynk@hotmail.com\">ipassynk@hotmail.com</a></span></h5></div></div></div>");
$templateCache.put("app/layout/main/main.html","<div class=\"container-fluid\"><div class=\"row\"><ps-navbar></ps-navbar></div><div class=\"row\"><ps-alerts></ps-alerts></div></div><div ui-view=\"main\" role=\"main\" class=\"container-fluid\"></div><footer id=\"footer\" role=\"contentinfo\"><div class=\"container-fluid footer-inner\"><ps-footer></ps-footer></div></footer>");
$templateCache.put("app/layout/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse col-sm-12\" role=\"navigation\" id=\"ps-navbar\"><a class=\"navbar-brand pull-left\" ui-sref=\"container.home\"><img src=\"assets/images/petstore_logo.png\" alt=\"Julia PetStore Logo\"></a><ul class=\"nav navbar-nav pull-right\"><li class=\"nav-item\"><a class=\"nav-link\" ui-sref=\"container.add\"><span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span> New Pet</a></li></ul></nav>");
$templateCache.put("app/states/add/add.html","<div class=\"row\" id=\"add\"><div class=\"page-header text-center\"><h1>Let\'s create a pet!</h1></div><hr><ps-pet-add></ps-pet-add></div>");
$templateCache.put("app/states/home/home.html","<section class=\"row pet-home-jumbotron\"><div class=\"jumbotron text-center\"><h1>Welcome to Julia Pet Store!</h1><p class=\"lead\"><img class=\"img-responsive img-circle\" src=\"assets/images/hero_pet.jpg\" alt=\"Hero pet\"></p></div></section><section class=\"row pet-home-well\"><div class=\"well col-sm-10 col-sm-offset-1\"><h2 class=\"text-center\">Easy way to find your pet!</h2><ps-pet-search></ps-pet-search></div></section><section class=\"row\"><ps-pet-thumbnail></ps-pet-thumbnail></section>");}]);